import React, { useEffect, useState } from "react";
import { Form, Input, Button, Upload, Row, Col, message, Typography } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import axios from "axios";

const { Title } = Typography;

const TestimonialForm = ({ formData, setFormData, closeModal, refetchData }) => {
  const [form] = Form.useForm();
  const [file, setFile] = useState(null);

  useEffect(() => {
    if (formData) {
      form.setFieldsValue(formData);
      if (formData.image) {
        setFile({
          uid: "-1",
          name: "Uploaded Image",
          status: "done",
          url: formData.image,
        });
      }
    }
  }, [formData]);

  const handleFileChange = ({ file }) => {
    if (file.status === "removed") {
      setFile(null);
    } else {
      setFile(file.originFileObj);
    }
  };

  const beforeUpload = (file) => {
    setFile(file);
    return false; // Prevent automatic upload by Ant Design
  };

  const onFinish = async (values) => {
    const payload = new FormData();

    Object.keys(values).forEach((key) => {
      payload.append(key, values[key]);
    });

    if (file) {
      payload.append("image", file); // Ensure the correct field name
    }

    try {
      if (formData.id) {
        await axios.put(`http://93.127.203.113:5005/testimonials/${formData.id}`, payload, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        message.success("Testimonial updated successfully");
      } else {
        await axios.post("http://93.127.203.113:5005/testimonials", payload, {
          headers: { "Content-Type": "multipart/form-data" },
        });
        message.success("Testimonial created successfully");
      }
      refetchData();
      closeModal();
    } catch (error) {
      console.error("Error:", error);
      message.error("Failed to save testimonial.");
    }
  };

  return (
    <div style={{ padding: "20px" }}>
      <Title level={4} style={{ color: "#0c8c49", marginBottom: "20px" }}>
        {formData.id ? "Edit Testimonial" : "Create Testimonial"}
      </Title>
      <Form form={form} onFinish={onFinish} layout="vertical">
        <Row gutter={16}>
          <Col span={12}>
            <Form.Item label="Name" name="name" rules={[{ required: true, message: "Please enter name" }]}>
              <Input placeholder="Enter name" />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label="Company" name="company" rules={[{ required: true, message: "Please enter company" }]}>
              <Input placeholder="Enter company name" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={24}>
            <Form.Item label="Message" name="message" rules={[{ required: true, message: "Please enter a message" }]}>
              <Input.TextArea rows={3} placeholder="Enter testimonial message" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={24}>
            <Form.Item label="Upload Image">
              <Upload
                listType="picture"
                maxCount={1} // Ensures only one file is uploaded
                beforeUpload={beforeUpload}
                onRemove={() => setFile(null)}
              >
                <Button icon={<UploadOutlined />}>Upload Image</Button>
              </Upload>
            </Form.Item>
          </Col>
        </Row>
        <Form.Item>
          <Button type="primary" htmlType="submit" style={{ backgroundColor: "#0c8c49", borderColor: "#0c8c49" }}>
            Save
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default TestimonialForm;
